import Modal from '@/components/modals/modal/modal.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import CurrencyFormatInputEdit from '@/components/currency-format-input-edit/currency-format-input-edit.vue'
import { numberWithSeparator } from '@/utils/format-strings'
import emitHideMixin from '@/components/modals/mixins/emit-hide'

export default {
  name: 'ExchangeCashInStockModal',
  /**
   * emitHideMixin - методы hide и onHideModal
   */
  mixins: [ emitHideMixin ],
  props: {
    cashInStock: {
      type: Number,
      default: 0
    },
    cashOnRoute: {
      type: Number,
      default: 0
    }
  },
  components: {
    Modal,
    ValidationObserver,
    ValidationProvider,
    CurrencyFormatInputEdit
  },
  data() {
    return {
      form: {
        exchangeCashInStock: 0
      }
    }
  },
  methods: {
    numberWithSeparator,
    show () {
      this.form.exchangeCashInStock = this.cashInStock
      this.$refs.modal.show()
    },
    /**
     * Закрывать из компонента-родителя
     */
     onSubmit() {
      this.$refs['observer'].validate().then(async success => {
        if (success) {
          this.$emit('create-exchange-cash', this.form.exchangeCashInStock)
        }
      })
    }
  }
}